module.exports = __webpack_public_path__ + "img/batteries.0a7d4cba.svg";